import styled from "styled-components";

export const MyHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding-right: 12px;
`;

export const HeaderText = styled.p`
  font-family: "SangBleu Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 36px;
  line-height: 44px;
  letter-spacing: -0.02em;
  color: #05162a;
`;
